import React, { useEffect } from 'react';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../../context/AuthContext';
import ScrollBox from '../../../components/ScrollBox';
import { Button, Stack, Typography, useTheme } from '@mui/material';
import CtrlFillLabelTxtField from '../../../components/CtrlFillLabelTxtField';
import BgBoxOld from '../../../components/BgBoxOld';
import CtrlCustomDropDownOld from '../../../components/CtrlCustomDropDownOld';
import { customAlert, notify } from '../../../components/notify';
import route from '../../../utils/Routes';
import { editDoInvServ, getSinglePoProdServ } from '../../../services/com-service';
import { useQuery, useQueryClient } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { datePickerformat, isNotEmpty } from '../../../utils/format';


const pymtStatusArr = [
    { value: "paid", label: "PAID" },
    { value: "unpaid", label: "UNPAID" },
    { value: "partially_paid", label: "PARTIALLY PAID" }];

function EditPotInvPage() {
    const theme = useTheme();
    const location = useLocation();
    const queryClient = useQueryClient();
    const { setLoadingScreen, setSelComValue } = useAuthContext();
    const { poProdId, comId, comName, comLogo, potProjDet, pgNo, s, st } = location.state;
    const navigate = useNavigate();
    const txtFieldProps = { fontSize: 12, height: 35 };
    const [prodVal, setProdVal] = useState({ poIdStrg: "", lineNo: "", comProdIdStrg: "" })
    const [doArr, setDoArr] = useState([]);
    const { isLoading, isError, error, data: prodData } = useQuery([QueryKey.amctSinglePoProd, poProdId], () => getSinglePoProdServ(poProdId),
        {
            enabled: isNotEmpty(poProdId),
            refetchOnMount: false,
            refetchOnWindowFocus: false,
        })

    useEffect(() => {
        if (!comId) {
            notify("error", "Company not found!---");
            navigate(-1);
        } else {
            setSelComValue({ comId, comName, comLogo, potProjDet })
        }

        if (!poProdId) {
            notify("error", "Company not found!----");
            navigate(-1);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comId, comName, comLogo, poProdId, potProjDet]);

    useEffect(() => {
        if (isLoading) {
            setLoadingScreen(true);
        } else {
            setLoadingScreen(false);
        }
    }, [isLoading, setLoadingScreen]);

    useEffect(() => {
        if (!prodData)
            return;
        setDoArr(formatApiResData(prodData));

        setProdVal({ poIdStrg: prodData?.poIdStrg, lineNo: prodData?.lineNo, comProdIdStrg: prodData?.comProdIdStrg })
    }, [prodData]);

    function formatApiResData(data) {
        const tempDoArr = data?.doProdArr ? data?.doProdArr.map((i) => {
            return {
                id: i.id,
                doLineNo: i.doLineNo,
                doIdStrg: i.doIdStrg,
                deliveredQty: i.deliveredQty,
                deliveredAt: datePickerformat(i?.deliveredAt),
                invNo: i.invNo,
                invDate: datePickerformat(i?.invDate),
                pymtStatus: i.pymtStatus
            }
        }) : [];

        return tempDoArr;
    }

    async function handleSubmit(e) {
        e.preventDefault();
        // const formData = new FormData(e.target);
        // const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object


        setLoadingScreen(true);
        try {
            const payload = {
                poProdId,
                doInvArr: doArr.map((i) => {
                    return {
                        id: i.id,
                        invNo: i.invNo,
                        invDate: i.invDate,
                        pymtStatus: i.pymtStatus
                    }
                })
            };

            console.dir(payload);
            const { message } = await editDoInvServ(payload);
            notify("success", message);
            queryClient.invalidateQueries();
            navigate(`${route.accPoTrackingList}/?comId=${comId}&pgNo=${pgNo}&st=${st}&s=${encodeURIComponent(s)}`, { replace: true })
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    };

    async function handleCancel() {
        navigate(`${route.accPoTrackingList}/?comId=${comId}&pgNo=${pgNo}&st=${st}&s=${encodeURIComponent(s)}`, { replace: true })
    }




    const handleProdValChange = (index, e) => {
        const { name: field, value } = e.target;
        const updatedDoArr = [...doArr];
        updatedDoArr[index][field] = value
        setDoArr(updatedDoArr);
    };


    useEffect(() => {
        console.dir(doArr)
    }, [doArr])


    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (
        <Stack height={"100%"} width={"100%"}>
            <form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%" }}>
                <Stack direction={'row'} justifyContent='space-between' alignItems='center' my={1} pl={5} pr={10}>
                    <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>EDIT INVOICES</Typography>
                    <Stack direction={'row'} alignItems='center' gap={1} >
                        <Button variant="text" sx={{ height: 30, width: 120, color: theme.palette.custom.btn }} onClick={handleCancel}>{"Cancel"}</Button>
                        <Button variant="contained" type='submit' sx={{ height: 30, width: 120, color: "white", backgroundColor: theme.palette.custom.btn }}>
                            {"SAVE"}</Button>
                    </Stack>
                </Stack>
                <BgBoxOld height={"93%"} py={1}>
                    <Stack direction={"row"} gap={5}>
                        <CtrlFillLabelTxtField name="poReqNo" title={"PO NUMBER"}  {...txtFieldProps} bgColor={"rgba(162, 214, 249, 0.1)"}
                            value={prodVal?.poIdStrg} readOnly={true} />
                        <CtrlFillLabelTxtField name="lineNo" title={"POL"} {...txtFieldProps} bgColor={"rgba(162, 214, 249, 0.2)"}
                            value={prodVal?.lineNo} readOnly={true} width={100} />
                        <CtrlFillLabelTxtField name="lineNo" title={"MATERIAL CODE"} {...txtFieldProps} bgColor={"rgba(162, 214, 249, 0.1)"}
                            value={prodVal?.comProdIdStrg} readOnly={true} />
                    </Stack>

                    <Stack direction={'row'} alignItems='center' mt={3} >
                        <Typography sx={{ fontSize: 17, fontWeight: "bold" }}>List of DOs:</Typography>
                    </Stack>
                    <ScrollBox height={"80%"} width={"100%"}>{
                        doArr.map((doItem, di) => (
                            <Stack key={`${di}`} sx={{
                                px: 2, py: 2, borderRadius: 1.4, gap: 2, mb: 2,
                                backgroundColor: "rgba(162, 214, 249, 0.2)", width: "100%"
                            }}>
                                <Stack direction={"row"} gap={2} alignItems={"center"}>
                                    <CtrlFillLabelTxtField name="doLineNo" title={"DOL"}  {...txtFieldProps} width={100} type="number"
                                        step={1} value={doItem.doLineNo} readOnly={true} bgColor={"rgba(162, 214, 249, 0.1)"} />
                                    <CtrlFillLabelTxtField name="doIdStrg" title={"DO NUMBER"} {...txtFieldProps} width={170}
                                        value={doItem.doIdStrg} readOnly={true} bgColor={"rgba(162, 214, 249, 0.1)"} />

                                    <CtrlFillLabelTxtField name="deliveredQty" title={"QTY"}  {...txtFieldProps} width={170} type="number"
                                        step={1} value={doItem.deliveredQty} readOnly={true} bgColor={"rgba(162, 214, 249, 0.1)"} />
                                    <CtrlFillLabelTxtField name="deliveredAt" type={"date"} title={"DELIVERED ON"} {...txtFieldProps}
                                        width={170} value={doItem.deliveredAt} readOnly={true} bgColor={"rgba(162, 214, 249, 0.1)"} />

                                    <CtrlFillLabelTxtField name="invNo" title={"INVOICE NO"}  {...txtFieldProps} width={200}
                                        value={doItem.invNo} onChange={(e) => handleProdValChange(di, e)} />
                                    <CtrlFillLabelTxtField name="invDate" title={"INVOICE DATE"} {...txtFieldProps} width={200}
                                        type="date" step={1} value={doItem.invDate} onChange={(e) => handleProdValChange(di, e)} />
                                    <CtrlCustomDropDownOld title={"PAYMENT STATUS"} name={"pymtStatus"} ddArr={pymtStatusArr} bgColor={"#fff"}
                                        {...txtFieldProps} width={300} value={doItem.pymtStatus} onChange={(e) => handleProdValChange(di, e)} />
                                </Stack>
                            </Stack>))}
                    </ScrollBox>
                </BgBoxOld>
            </form>
        </Stack>
    )
}

export default EditPotInvPage